<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">{{ $t('Trial-Balance-of-Currency') }}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
              </v-text-field>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>

            <v-card color="grey lighten-5" flat>
              <v-form ref="formtarih" v-model="valid" lazy-validation>

                <v-layout row wrap>

                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                      :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date"
                      v-model="date"></tarihcomp>


                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                      :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date2"
                      v-model="date2"></tarihcomp>
                  </v-flex>

                  <v-flex>
                    <v-layout>
                      <div v-if="load1">
                        <v-btn color="info" @click="getList()" fab small="" dark>
                          <v-icon>search</v-icon>
                        </v-btn>
                      </div>

                      <v-badge color="white" :overlap="true">
                        <template v-slot:badge>
                          <v-icon v-if="filtrevarmi" large color="green">
                            check_circle_outline </v-icon>
                        </template>

                        <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                          @click="filtrele()" color="info" fab dark>
                          <v-icon>filter_list</v-icon>
                        </v-btn>
                        <v-tooltip bottom="" :activator="el" v-model="tooltip">
                          <span>{{$t('Add-Search-Filter')}}</span>
                        </v-tooltip>

                      </v-badge>
                    </v-layout>
                  </v-flex>

                  <v-dialog v-model="dialogfiltre" persistent="" max-width="530px">
                    <v-card color="grey lighten-5">
                      <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>

                        <v-flex pa-1 xs12 sm12 md12>
                          <v-card>
                            <v-card color="grey lighten-5" flat="">
                              <v-card-actions>

                                <v-layout justify-space-between column>
                             
                                <cariaracomp v-bind:etiket="$t('Accound-Code')" :loading="loading" v-bind:value="Mizan.Cari.Kod" v-model="Mizan.Cari.Kod"></cariaracomp>
                                  <v-select :items="hesapgurubu" hide-details="" v-model="Mizan.HesapGrubu"
                                    :label="$t('Account-Group-Requested')" multiple item-text="Title" item-value="Kod"
                                    max-height="400"></v-select>
                                  <v-select :items="hesapgurubu" hide-details="" v-model="Mizan.NoHesapGrubu"
                                    :label="$t('Account-Group-Not-Requested')" multiple item-text="Title" item-value="Kod"
                                    max-height="400" persistent-hint></v-select>
                                </v-layout>
                              </v-card-actions>
                            </v-card>
                          </v-card>
                        </v-flex>
                        <v-flex pa-1 xs12 sm12 md12>
                          <v-layout justify-space-between column>
                            <v-card flat="" color="#9E9E9E">
                              <v-card-title>
                                <span class="subheading white--text font-weight-medium "> {{ $t('Options-v2') }}</span>
                              </v-card-title>
                            </v-card>
                            <v-radio-group hide-details="" v-model="Mizan.DonemKumulatif" column>
                              <v-radio :label="$t('Cumulative')" value="true">
                              </v-radio>
                              <v-radio :label="$t('Period')" value="false"></v-radio>
                            </v-radio-group>
                            <v-checkbox hide-details="" v-model="Mizan.FaturaTarih"
                              :label="$t('Get-Trial-Balance-by-Invoice-Date')"></v-checkbox>

                            <v-checkbox hide-details="" :label="$t('Do-Not-Show-Balances-below-1')"
                              v-model="Mizan.BakiyeBirAltiGosterme "></v-checkbox>


                            <v-checkbox hide-details="" v-model="tumsirketler" :label="$t('All-Companies')"></v-checkbox>
                          </v-layout>
                        </v-flex>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                        <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                </v-layout>
              </v-form>
            </v-card>
          </v-container>


          <v-container v-if="doviztrue" fluid>
            <v-flex xs12 sm12 md12>
              <v-card flat="" color="#9E9E9E">
                <v-card-title>
                  <span class="subheading white--text font-weight-medium "> {{$t('Currency-Report-Summary-Results')}} </span>
                </v-card-title>
              </v-card>

            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-card>
                <v-card-title>
                  <v-spacer></v-spacer>

                </v-card-title>
                <v-data-table :headers="headersdoviz" :rows-per-page-items=[50,100] :loading="progress"
                  :items="dovizList">
                  <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.DovizKod }}</td>
                    <td class="text-xs-right">{{ props.item.ToplamAlacak | moneyformat  }}</td>
                    <td class="text-xs-right">{{ props.item.ToplamAlacakBakiye | moneyformat}}</td>
                    <td class="text-xs-right">{{ props.item.ToplamBorc | moneyformat }}</td>
                    <td class="text-xs-right">{{ props.item.ToplamBorcBakiye | moneyformat}}</td>

                  </template>
                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    {{ $t('No-records-searched-for', { value: search3}) }}   
                  </v-alert>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-container>


          <v-container fluid>
            <v-flex xs12 sm12 md12>

              <v-card flat="" color="#9E9E9E">
                <v-card-title>
                  <span class="subheading white--text font-weight-medium "> {{ $t('Currency-Current-Account-Trial-Balance') }} </span>
                </v-card-title>
              </v-card>


            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-card>

                <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                  :search="search3">
                  <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.Kod }}</td>
                    <td class="text-xs-left">{{ props.item.Unvan }}</td>
                    <td class="text-xs-left">{{ props.item.DovizKod}}</td>
                    <td class="text-xs-right">{{ props.item.CariBorc | moneyformat}}</td>
                    <td class="text-xs-right">{{ props.item.CariAlacak | moneyformat}}</td>
                    <td class="text-xs-right">{{ props.item.BorcBakiye | moneyformat }}</td>
                    <td class="text-xs-right">{{ props.item.AlacakBakiye | moneyformat }}</td>
                  </template>
                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    {{ $t('No-records-searched-for', { value: search3}) }}  
                  </v-alert>
                </v-data-table>
              </v-card>

              <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
              </v-snackbar>
            </v-flex>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'


  export default {
    data() {
      return {
        PB:'TRY',
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        search: '',
        dovizList: [],


        headersdoviz: [{
            text: this.$t('Currency-Code'),
            value: 'DovizKod'
          },
          {
            text: this.$t('Total-Credit'),
            value: 'ToplamAlacak',
            align: 'right'

          },
          {
            text: this.$t('Total-Credit-Balance'),
            value: 'ToplamAlacakBakiye',
            align: 'right'

          },
          {
            text: this.$t('Total-Debit'),
            value: 'ToplamBorc',
            align: 'right'

          },
          {
            text: this.$t('Total-Debit-Balance'),
            value: 'ToplamBorcBakiye',
            align: 'right'

          }
        ],




        headers: [{
            text: this.$t('Accound-Code'),
            value: 'Kod'
          },
          {
            text: this.$t('Account-Name'),
            value: 'Unvan'
          },
          {
            text: this.$t('Currency'),
            value: 'DovizKod'
          },
          {
            text: this.$t('Current-Payable'),
            value: 'CariBorc',
            align: 'right'

          },
          {
            text: this.$t('Current-Receivable'),
            value: 'CariAlacak',
            align: 'right'

          },
          {
            text: this.$t('Debt-Balance'),
            value: 'BorcBakiye',
            align: 'right'

          },
          {
            text: this.$t('Balance-Receivable'),
            value: 'AlacakBakiye',
            align: 'right'

          }
        ],
        valid: true,
        Mizan: {
          SirketKodu: '',
          Cari: {
            Kod: '',
          },
          HesapGrubu: '',
          NoHesapGrubu: '',
          DonemKumulatif: '',
          BaslangicTarih: this.date,
          BitisTarih: this.date2,
          FaturaTarih: '',
          BakiyeBirAltiGosterme: false,
          Unvan: '',
          DovizKod: '',
          CariBorc: '',
          CariAlacak: '',
          BorcBakiye: '',
          AlacakBakiye: ''
        },
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        loading1: false,
        progress: false,
        search1: '',
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        anahesap: [],
        hesapgurubu: [],
        mizan: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        doviztrue: false,
        tumsirketler: false,
        tooltip: false,
        el: null,
        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp,
      yetkidialog,
      cariaracomp
    },
    mounted() {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      if (this.sayfayetki.Status == true) {

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    watch: {
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
    methods: {

      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

  }

  function filtrekayit() {
    this.filtrevarmi = true
    this.dialogfiltre = false
    this.getList();
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false
  }

  function getList() {

    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.Mizan.BaslangicTarih = this.date
        this.Mizan.BitisTarih = this.date2
        if (this.tumsirketler === true) {
          this.Mizan.SirketKodu = '0'
        } else {
          this.Mizan.SirketKodu = credentials.SirketKodu
        }

        var params = this.Mizan

        this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrency', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.mizan = false

          if (response.body.DovizList.length > 0) {
            this.doviztrue = true
          } else {
            this.doviztrue = false
          }



          this.dovizList = response.body.DovizList
          this.items = response.body.MizanList
          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.mizan = false
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.mizan = false
            this.progress = false
            this.load1 = true
          }
        })

      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }

  }

  function getListHtml() {
    this.load1 = false
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var lang = localStorage.getItem('lang')
    this.Mizan.BaslangicTarih = this.date
    this.Mizan.BitisTarih = this.date2
    if (this.tumsirketler === true) {
      this.Mizan.SirketKodu = '0'
    } else {
      this.Mizan.SirketKodu = credentials.SirketKodu
    }

    var params = this.Mizan

    this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrencyHtmlReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      if (lang=='en')
          {
            
            var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> DOVİZLİ MİZANI </title>','<title> CURRENCY TRIAL BALANCE </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>DOVİZLİ MİZANI</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>CURRENCY TRIAL BALANCE</font>")

            
             response.bodyText=bodyhtml;
             
          }
      this.load = false
      this.load1 = true
      var blob = new Blob([response.bodyText], {
        type: 'application/html'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "TrialBalanceCurrency" + ".html";
      link.click();
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.mizan = false
        this.progress = false
        this.load1 = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.mizan = false
        this.progress = false
        this.load1 = true
      }
    })
  }

  function getListExcel() {
    this.load1 = false


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.Mizan.BaslangicTarih = this.date
    this.Mizan.BitisTarih = this.date2
    if (this.tumsirketler === true) {
      this.Mizan.SirketKodu = '0'
    } else {
      this.Mizan.SirketKodu = credentials.SirketKodu
    }

    var params = this.Mizan

    this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrencyExcelReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      },
      responseType: "arraybuffer"
    }).then((response) => {
      this.load = false
      this.load1 = true
      var blob = new Blob([response.data], {
        type: 'application/xlsx'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "TrialBalanceCurrency" + ".xlsx";
      link.click();
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.mizan = false
        this.progress = false
        this.load1 = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.mizan = false
        this.progress = false
        this.load1 = true
      }
    })
  }

  function beforeMount() {
    this.mizan = false

  }

</script>

<style>
</style>